import { CampaignUserReviewStatus, CampaignUserUploadStatus } from "@/api/__generated__/models";
import { Badge } from "@backpac/monica";
import { useMemo } from "react";

export function UserUploadStatusBadge({
  userUploadStatus,
  userReviewStatus,
  className,
}: { userUploadStatus: CampaignUserUploadStatus; userReviewStatus: CampaignUserReviewStatus; className?: string }) {
  const { label, theme } = useMemo(() => {
    if (userUploadStatus === CampaignUserUploadStatus.UPCOMING) {
      return { label: "Upcoming upload", theme: "orange" as const };
    }
    if (userUploadStatus === CampaignUserUploadStatus.AVAILABLE) {
      return { label: "Not submitted", theme: "red" as const };
    }
    if (userUploadStatus === CampaignUserUploadStatus.SUBMITTED) {
      if (userReviewStatus === CampaignUserReviewStatus.PENDING) {
        return { label: "Under review", theme: "orange" as const };
      }
      if (userReviewStatus === CampaignUserReviewStatus.APPROVED) {
        return { label: "Approved", theme: "green" as const };
      }
      if (userReviewStatus === CampaignUserReviewStatus.REJECTED) {
        return { label: "Rejected", theme: "red" as const };
      }
    }
    if (userUploadStatus === CampaignUserUploadStatus.EXPIRED) {
      return { label: "Expired", theme: "red" as const };
    }
    throw new Error("Invalid user upload status");
  }, [userUploadStatus, userReviewStatus]);

  return (
    <Badge theme={theme} className={className}>
      {label}
    </Badge>
  );
}
